__turbopack_context__.v({
  "address": "BlocksPage-module__6jinSa__address",
  "age": "BlocksPage-module__6jinSa__age",
  "container": "BlocksPage-module__6jinSa__container",
  "controls": "BlocksPage-module__6jinSa__controls",
  "emptyState": "BlocksPage-module__6jinSa__emptyState",
  "fee": "BlocksPage-module__6jinSa__fee",
  "info": "BlocksPage-module__6jinSa__info",
  "infoIcon": "BlocksPage-module__6jinSa__infoIcon",
  "infoValue": "BlocksPage-module__6jinSa__infoValue",
  "link": "BlocksPage-module__6jinSa__link",
  "pageButton": "BlocksPage-module__6jinSa__pageButton",
  "pageButtonActive": "BlocksPage-module__6jinSa__pageButtonActive",
  "pagination": "BlocksPage-module__6jinSa__pagination",
  "rightControls": "BlocksPage-module__6jinSa__rightControls",
  "shimmer": "BlocksPage-module__6jinSa__shimmer",
  "skeleton": "BlocksPage-module__6jinSa__skeleton",
  "tab": "BlocksPage-module__6jinSa__tab",
  "tabActive": "BlocksPage-module__6jinSa__tabActive",
  "table": "BlocksPage-module__6jinSa__table",
  "tableContainer": "BlocksPage-module__6jinSa__tableContainer",
  "tabs": "BlocksPage-module__6jinSa__tabs",
  "title": "BlocksPage-module__6jinSa__title",
  "value": "BlocksPage-module__6jinSa__value",
});
